<ng-container *transloco="let t; read: 'reasons'">
  <h1 [innerHTML]="t('title')"></h1>
  <section class="article">
    <article>
      <div class="text" [innerHTML]="t('content')"></div>
    </article>
  </section>

  <section class="blocks inverted">
    <div class="blocks">
      <article>
        <div>
          <img src="assets/s1_filmaufnahme_1.jpg" alt="Filmaufnahme" />
        </div>
        <h3>{{ t("recording-title") }}</h3>
        <div>{{ t("recording-text") }}</div>
      </article>
      <article>
        <div>
          <img src="assets/s2_konvertierung_1.jpg" alt="Konvertierung" />
        </div>
        <h3>{{ t("conversion-title") }}</h3>
        <div [innerHTML]="t('conversion-content')"></div>
      </article>
      <article>
        <div>
          <img src="assets/s3_speicherung_2.jpg" alt="Speicherung" />
        </div>
        <h3>{{ t("distribution-title") }}</h3>
        <div [innerHTML]="t('distribution-content')"></div>
      </article>
    </div>
  </section>
  <section class="article">
    <article>
      <a [routerLink]="['/home']" class="call">{{ t("back-button") }}</a>
    </article>
  </section>
</ng-container>
